import { ConditionsManager } from '@/shared/components/conditions/models/conditionsManager';
import {store} from '@/store';

export class FiltersManager extends ConditionsManager {
	constructor() {
		super(store.getters.contactAttributes);
	}
}
